

  import {Component, Model, Prop, Vue, Watch} from "vue-property-decorator";
  import api from '@/api/index';

  @Component({name:'OrganizationUnitSelect'})
  export default class OrganizationUnitSelect extends Vue{
    @Model('change',{type:Number})  readonly orgId!:number;

    @Prop({default:false})
    disabled!:boolean;

    @Prop({default:false})
    onlyStore!:boolean;

    // private fields
    value:number = 0;

    organizationUnits:any = [];

    @Watch('orgId')
    onOrgIdChange(newValue:number){
      console.log('<organization-unit-select>,onOrgIdChange:'+newValue);
      this.value = newValue;
    }



    async  created(){
      this.value = this.orgId;
      if(this.onlyStore){
        await api.organizationUnit.getStoresBySession({}).then(res=>{
          this.organizationUnits = res;
        })
      } else {
       await api.organizationUnit.getOrganizationUnitsOfDescendantBySession().then(res=>{
         this.organizationUnits = res;
       })
      }

    }

    handleValueChange(newValue:String){
      this.$emit('change',newValue);
    }


  }
